/* ── CARRITO YAIZA: proteccion de envio + carrusel + regalo ── 22-ago-2026 ──
   Se carga desde snippets/cart-drawer.liquid.
   Todo va delegado en document: .drawer__inner se re-renderiza entero y cualquier
   listener enganchado a un boton concreto se perderia en el primer re-render. */
(function () {
  if (window.yzCartExtrasReady) return;
  window.yzCartExtrasReady = true;

  var busy = false;

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' -> ' + r.status);
      return r.json();
    });
  }

  /* Repinta el drawer y DEVUELVE UNA PROMESA DE VERDAD.
     No se usa drawer.updateCart() aunque exista: esa funcion no devuelve promesa, asi que
     'busy' se liberaba antes de que el DOM tuviera el estado nuevo y el guard volvia a
     abrir el modal de regalo con datos viejos (carrera medida en vivo el 22-ago).
     Se reenganchan los botones del upsell porque cart-drawer.js los ata tras cada render. */
  function repintarDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inner = document.querySelector('.drawer__inner');
        var nuevo = parsed.querySelector('.drawer__inner');
        if (inner && nuevo) inner.innerHTML = nuevo.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          if (typeof drawer.initializeUpsellButtons === 'function') drawer.initializeUpsellButtons();
          if (typeof drawer.initializeVariantSelectors === 'function') drawer.initializeVariantSelectors();
        }
        // El innerHTML de arriba se lleva por delante la barra de progreso: se repinta ya,
        // sin esperar al debounce de 250 ms del observer, para que no parpadee.
        pintarProgresoRegalo();
      })
      .catch(function (e) { console.error('Repintar carrito:', e); });
  }

  function estado() {
    var e = document.getElementById('yz-sp-state');
    if (!e) return null;
    return {
      visibles: parseInt(e.getAttribute('data-yz-sp-visible'), 10),
      spKey: e.getAttribute('data-yz-sp-key'),
      giftOk: e.getAttribute('data-yz-gift-ok') === 'true',
      giftKey: e.getAttribute('data-yz-gift-key'),
      giftVariant: e.getAttribute('data-yz-gift-variant'),
      base: parseInt(e.getAttribute('data-yz-base'), 10) || 0,
      minimo: parseInt(e.getAttribute('data-yz-gift-min'), 10) || 7500
    };
  }

  /* ── 1. PROTECCION DE ENVIO ─────────────────────────────── */
  document.addEventListener('click', function (event) {
    var sw = event.target.closest ? event.target.closest('.yz-sp__switch') : null;
    if (!sw || busy) return;

    var activa = sw.getAttribute('aria-checked') === 'true';
    var lineKey = sw.getAttribute('data-yz-sp-key');
    var variantId = parseInt(sw.getAttribute('data-yz-sp-variant'), 10);
    if (!activa && !variantId) return;
    if (activa && !lineKey) return;

    busy = true;
    sw.setAttribute('data-busy', '1');
    sw.setAttribute('aria-checked', activa ? 'false' : 'true');

    var peticion = activa
      ? postJSON('/cart/change.js', { id: lineKey, quantity: 0 })
      : postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });

    peticion
      .then(repintarDrawer)
      .catch(function (e) {
        console.error('Proteccion de envio:', e);
        sw.setAttribute('aria-checked', activa ? 'true' : 'false');
      })
      .finally(function () {
        busy = false;
        sw.removeAttribute('data-busy');
      });
  });

  /* ── 2. CARRUSEL "QUIZAS TE INTERESE" ───────────────────────
     Dos trampas medidas en vivo:
     a) El tema pone scroll-behavior:smooth en <html>. Con eso, cualquier 'scrollLeft = x'
        se convierte en animacion; si la pestana no compone fotogramas la animacion no
        avanza y el track se queda en 0. Se mueve SIEMPRE con scrollTo({behavior:'instant'}).
     b) scroll-snap mandatory reengancha las posiciones intermedias: se apaga el snap
        durante la animacion y se restaura al final (el destino ya es un punto de snap).
     Red de seguridad: a los 450 ms se coloca el destino a pelo y se restaura el snap. */
  function irA(track, x) {
    track.scrollTo({ left: x, behavior: 'instant' });
  }

  function pintarFlechas(track) {
    var wrap = track.closest('.yz-upsell-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-yz-upsell-prev]');
    var next = wrap.querySelector('[data-yz-upsell-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function moverCarrusel(track, dir) {
    var card = track.querySelector('.upsell-product');
    if (!card) return;
    var paso = card.getBoundingClientRect().width + 10;
    if (paso < 20) return;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var idx = Math.round(track.scrollLeft / paso) + dir;
    var destino = Math.max(0, Math.min(max, idx * paso));
    var inicio = track.scrollLeft;
    var delta = destino - inicio;
    if (Math.abs(delta) < 1) return;

    track.style.scrollSnapType = 'none';
    var cerrado = false;

    function cerrar() {
      if (cerrado) return;
      cerrado = true;
      if (Math.abs(track.scrollLeft - destino) > 2) irA(track, destino);
      track.style.scrollSnapType = '';
      pintarFlechas(track);
    }

    var t0 = null;
    function frame(ts) {
      if (cerrado) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / 280);
      irA(track, inicio + delta * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(frame);
      else cerrar();
    }
    requestAnimationFrame(frame);
    setTimeout(cerrar, 450);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var btn = event.target.closest('[data-yz-upsell-prev], [data-yz-upsell-next]');
    if (!btn) return;
    event.preventDefault();
    var wrap = btn.closest('.yz-upsell-wrap');
    var track = wrap && wrap.querySelector('[data-yz-upsell-track]');
    if (!track) return;
    moverCarrusel(track, btn.hasAttribute('data-yz-upsell-next') ? 1 : -1);
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var t = event.target;
      if (t && t.hasAttribute && t.hasAttribute('data-yz-upsell-track')) pintarFlechas(t);
    },
    true
  );

  /* ── 3. REGALO ──────────────────────────────────────────── */
  var modal = null;

  function refModal() {
    var todos = document.querySelectorAll('#yz-gift-modal');
    if (!todos.length) { modal = null; return null; }
    for (var i = 0; i < todos.length - 1; i++) todos[i].remove();
    var m = todos[todos.length - 1];
    // Fuera del drawer: sus ancestros tienen transform y position:fixed no funcionaria dentro.
    if (m.parentElement !== document.body) document.body.appendChild(m);
    modal = m;
    return modal;
  }

  /* En escritorio el carrito es un panel estrecho a la derecha: el modal se queda DENTRO
     de ese panel (mismo ancho, pegado a la derecha) para no invadir la tienda entera.
     En movil el carrito ya ocupa toda la pantalla, asi que el modal va a pantalla completa. */
  function anclarModal() {
    if (!modal) return;
    var wrapper = document.querySelector('.drawer__inner--wrapper');
    var ancho = wrapper ? Math.round(wrapper.getBoundingClientRect().width) : 0;
    if (ancho > 0 && window.innerWidth >= 750 && ancho < window.innerWidth - 40) {
      modal.style.left = 'auto';
      modal.style.right = '0';
      modal.style.width = ancho + 'px';
    } else {
      modal.style.left = '';
      modal.style.right = '';
      modal.style.width = '';
    }
  }

  function marcarSeleccion(variantId) {
    if (!refModal()) return;
    var cards = modal.querySelectorAll('.yz-gift-card');
    var alguno = false;
    for (var i = 0; i < cards.length; i++) {
      var esta = String(cards[i].getAttribute('data-yz-gift-variant')) === String(variantId);
      cards[i].setAttribute('aria-pressed', esta ? 'true' : 'false');
      if (esta) alguno = true;
    }
    var cta = modal.querySelector('[data-yz-gift-add]');
    if (cta) cta.disabled = !alguno;
  }

  // manual = lo abrio la clienta (banner o "Cambiar"). Si lo abrio el guard es automatico
  // y se cierra solo en cuanto ya hay un regalo en el carrito.
  function abrirModal(manual) {
    if (!refModal()) return;
    var st = estado();
    marcarSeleccion(st && st.giftVariant ? st.giftVariant : '');
    modal.dataset.manual = manual ? '1' : '';
    anclarModal();
    modal.hidden = false;
  }

  function cerrarModal(porUsuario) {
    if (!refModal()) return;
    modal.hidden = true;
    modal.dataset.manual = '';
    if (porUsuario) {
      // Solo silencia el auto-abrir MIENTRAS el carrito siga abierto. Al cerrar el
      // carrito se borra la marca, asi que al anadir otro producto vuelve a saltar.
      try { sessionStorage.setItem('yzGiftCerrado', '1'); } catch (e) {}
    }
  }

  window.addEventListener('resize', function () {
    if (modal && !modal.hidden) anclarModal();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    if (event.target.closest('[data-yz-gift-open]')) {
      event.preventDefault();
      try { sessionStorage.removeItem('yzGiftCerrado'); } catch (e) {}
      abrirModal(true);
      return;
    }
    if (event.target.closest('[data-yz-gift-close]')) {
      event.preventDefault();
      cerrarModal(true);
      return;
    }

    var card = event.target.closest('.yz-gift-card');
    if (card) {
      event.preventDefault();
      marcarSeleccion(card.getAttribute('data-yz-gift-variant'));
      return;
    }

    var quitar = event.target.closest('[data-yz-gift-remove]');
    if (quitar && !busy) {
      event.preventDefault();
      var st = estado();
      if (!st || !st.giftKey) return;
      busy = true;
      try { sessionStorage.setItem('yzGiftCerrado', '1'); } catch (e) {}
      postJSON('/cart/change.js', { id: st.giftKey, quantity: 0 })
        .then(repintarDrawer)
        .catch(function (e) { console.error('Regalo (quitar):', e); })
        .finally(function () { busy = false; });
      return;
    }

    var add = event.target.closest('[data-yz-gift-add]');
    if (add && !busy) {
      event.preventDefault();
      if (!refModal()) return;
      var elegido = modal.querySelector('.yz-gift-card[aria-pressed="true"]');
      if (!elegido) return;
      var nuevo = parseInt(elegido.getAttribute('data-yz-gift-variant'), 10);
      if (!nuevo) return;

      var st2 = estado();
      busy = true;
      add.disabled = true;

      var previo = st2 && st2.giftKey
        ? postJSON('/cart/change.js', { id: st2.giftKey, quantity: 0 })
        : Promise.resolve();

      previo
        .then(function () { return postJSON('/cart/add.js', { items: [{ id: nuevo, quantity: 1 }] }); })
        .then(function () {
          try { sessionStorage.removeItem('yzGiftCerrado'); } catch (e) {}
          cerrarModal(false);
          if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
          return repintarDrawer();
        })
        .catch(function (e) {
          console.error('Regalo (anadir):', e);
          // 6-sep-2026: antes fallaba en silencio (422 'agotado' con dos regalos sin stock) y el
          // boton parecia muerto. Ahora se dice en el propio modal y se deja elegir otro.
          var sub = modal && modal.querySelector('.yz-gift-modal__sub');
          if (sub) {
            if (!sub.dataset.original) sub.dataset.original = sub.textContent;
            sub.textContent = 'Ese regalo no está disponible ahora mismo. Elige otro.';
            sub.style.color = '#1F1C1C';
            setTimeout(function () { sub.textContent = sub.dataset.original; sub.style.color = ''; }, 4000);
          }
        })
        .finally(function () {
          busy = false;
          add.disabled = false;
        });
    }
  });

  /* ── 4. GUARDS + AUTO-APERTURA ──────────────────────────── */
  var guardEnCurso = false;

  function guard() {
    if (busy || guardEnCurso) return;
    var st = estado();
    if (!st) return;

    // 4a. La proteccion se quedo sola en el carrito -> fuera.
    if (st.visibles === 0 && st.spKey) {
      guardEnCurso = true;
      postJSON('/cart/change.js', { id: st.spKey, quantity: 0 })
        .then(repintarDrawer)
        .catch(function (e) { console.error('Proteccion (guard):', e); })
        .finally(function () { guardEnCurso = false; });
      return;
    }

    // 4b. Hay regalo pero ya no se llega al minimo -> fuera.
    if (st.giftKey && !st.giftOk) {
      guardEnCurso = true;
      postJSON('/cart/change.js', { id: st.giftKey, quantity: 0 })
        .then(repintarDrawer)
        .catch(function (e) { console.error('Regalo (guard):', e); })
        .finally(function () { guardEnCurso = false; });
      return;
    }

    if (!refModal()) return;

    var drawer = document.querySelector('cart-drawer');
    var abierto = drawer && drawer.classList.contains('active');

    // 4c. Carrito cerrado: el modal no puede quedarse en pantalla, y se borra la marca de
    //     "ya lo cerre" para que al volver a abrir el carrito (p.ej. al anadir otro
    //     producto) el panel de regalo vuelva a saltar solo.
    if (!abierto) {
      try { sessionStorage.removeItem('yzGiftCerrado'); } catch (e) {}
      if (!modal.hidden) cerrarModal(false);
      return;
    }

    // 4d. Modal abierto sin derecho a regalo -> cerrar.
    if (!modal.hidden && !st.giftOk) { cerrarModal(false); return; }

    // 4e. Ya hay regalo y el modal se abrio solo -> cerrarlo (si lo abrio ella, se queda).
    if (!modal.hidden && st.giftKey && modal.dataset.manual !== '1') { cerrarModal(false); return; }

    // 4f. 30-sep-2026 (noche) · Fabio, tras verlo en su móvil: el regalo VUELVE a saltar solo en cuanto
    //     se llega a 50 €, pero UNA SOLA VEZ POR VISITA (antes saltaba cada vez que se abría el carrito).
    //     Si lo cierra, queda la tarjeta «Tienes un regalo · Elegir» y la barra de premios de arriba.
    var yaSalto = false;
    try { yaSalto = sessionStorage.getItem('yzGiftAutoVisto') === '1'; } catch (e) {}
    // Con 2 cinturones pagados y el 3.º gratis aún sin elegir, primero manda el aviso de la Oferta Yaiza:
    // el regalo espera a que lo elija, para no tapar ese aviso.
    var eo = document.getElementById('yz-sp-state');
    var tercerPendiente = eo && (parseInt(eo.getAttribute('data-yzoy-pagados'), 10) || 0) === 2 &&
                          (parseInt(eo.getAttribute('data-yzoy-regalos'), 10) || 0) === 0;
    if (st.giftOk && !st.giftKey && !yaSalto && !tercerPendiente && modal.hidden) {
      try { sessionStorage.setItem('yzGiftAutoVisto', '1'); } catch (e) {}
      abrirModal(false);
    }
  }

  /* ── 5. BARRA DE PROGRESO AL REGALO ─────────────────────── 23-ago-2026 ──
     La home y la ficha prometen "Llega a 75 EUR y llevate tu regalo", pero el carrito
     no decia nada por debajo del umbral: se medio en vivo con 44,95 EUR y la clienta no
     tenia forma de saber que le faltaban 5,05 EUR. Esto cierra ese circuito.

     POR QUE VIVE EN EL JS Y NO EN EL LIQUID:
     el markup del cajon esta en snippets/cart-drawer.liquid, que pesa 48,9 KB. Reescribir
     ese fichero entero por un bloque nuevo es pedir un accidente, y ya el 22-ago se decidio
     sacar la logica aqui por lo mismo. El CSS se inyecta una sola vez desde este fichero
     para no tener que tocar tampoco sections/cart-drawer.liquid.

     DE DONDE SALE EL NUMERO:
     de data-yz-base del #yz-sp-state, que ya lo calcula el Liquid sobre las lineas REALES
     (sin regalo ni proteccion) y con el precio ANTES de descuentos. No se recalcula desde
     /cart.js a proposito: duplicar esa cuenta es garantizar que un dia las dos discrepen.

     SOLO SE PINTA POR DEBAJO DEL UMBRAL. Una vez desbloqueado ya hay un bloque
     "Tienes un regalo / Elegir" mas abajo; poner ademas una barra al 100 % seria decir
     lo mismo dos veces en un panel muy estrecho. */
  var UMBRAL_POR_DEFECTO = 7500; // centimos. SOLO es red de seguridad: desde el 24-ago el Liquid expone
                                   // data-yz-gift-min y ese manda. Si algun dia se cambia el umbral,
                                   // se cambia en snippets/cart-drawer.liquid, no aqui.

  function euros(centimos) {
    return (centimos / 100).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function inyectarCSSProgreso() {
    if (document.getElementById('yz-gift-progress-css')) return;
    var s = document.createElement('style');
    s.id = 'yz-gift-progress-css';
    s.textContent =
      '.yz-gift-progress{margin:0 0 14px;padding:12px 14px 10px;border:1px solid #E8E2DA;border-radius:12px;' +
      'background:linear-gradient(180deg,#FAF8F5 0%,#FAF8F5 100%);font-family:var(--font-body-family),Inter,sans-serif;}' +
      '.yz-gift-progress__txt{margin:0 0 9px;font-size:13px;line-height:1.35;color:#1F1C1C;text-align:center;}' +
      '.yz-gift-progress__txt b{font-weight:800;color:#1F1C1C;}' +
      '.yz-gift-progress__track{display:block;height:7px;border-radius:999px;background:#E8E2DA;overflow:hidden;}' +
      '.yz-gift-progress__fill{display:block;height:100%;border-radius:999px;background:#1F1C1C;' +
      'transition:width .45s cubic-bezier(.2,.6,.2,1);}' +
      '.yz-gift-progress__hitos{display:flex;justify-content:space-between;gap:8px;margin-top:7px;font-size:11.5px;' +
      'font-weight:600;color:#5A5552;}' +
      '.yz-gift-progress__hitos .ok{color:#2F7D4A;}' +
      '.yz-gift-progress--ok .yz-gift-progress__fill{background:#2F7D4A;}';
    document.head.appendChild(s);
  }

  /* 30-sep-2026 · Fabio: BARRA DE PREMIOS «Envío gratis ✓ → Regalo a 50 €», siempre a la vista con
     productos en el carrito (antes solo salía por debajo del umbral). Al llegar: «¡Regalo
     desbloqueado! Elígelo abajo» (el regalo ya no se abre solo). Con el regalo en el carrito:
     «Tu regalo ya está en tu pedido». Con la Oferta Yaiza (2 cinturones o el cinturón regalo) no hay
     regalo de 50 €: la barra no se pinta. */
  function pintarProgresoRegalo() {
    var inner = document.querySelector('.drawer__inner');
    var st = estado();
    var previo = document.querySelector('.drawer__inner .yz-gift-progress');
    var e = document.getElementById('yz-sp-state');
    // 30-sep-2026 (noche) · Fabio: el regalo de 50 € vale también con la Oferta Yaiza: la barra sale siempre.
    if (!inner || !st || st.base <= 0 || !st.visibles) {
      if (previo) previo.remove();
      return;
    }

    var minimo = st.minimo || UMBRAL_POR_DEFECTO;
    var falta = minimo - st.base;
    var llega = falta <= 0;
    var pct = llega ? 100 : Math.max(4, Math.min(100, Math.round((st.base / minimo) * 100)));
    var estadoTxt = st.giftKey ? 'ya' : (llega ? 'ok' : 'falta');
    var firma = pct + '|' + falta + '|' + estadoTxt;

    // El MutationObserver de abajo vigila el drawer entero, asi que escribir aqui sin
    // condicion dispararia otro repintado y de ahi a un bucle infinito. Si nada ha
    // cambiado, no se toca el DOM.
    if (previo && previo.dataset.firma === firma) return;

    var caja = previo;
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'yz-gift-progress';
      var ancla = inner.querySelector('cart-drawer-items');
      if (ancla) inner.insertBefore(caja, ancla);
      else inner.insertBefore(caja, inner.firstChild);
    }
    caja.dataset.firma = firma;
    caja.classList.toggle('yz-gift-progress--ok', llega);
    var txt = estadoTxt === 'ya' ? '<b>Tu regalo ya está en tu pedido</b> 🎁'
            : estadoTxt === 'ok' ? '<b>¡Regalo desbloqueado!</b> Elígelo abajo 🎁'
            : 'Te faltan <b>' + euros(falta) + '</b> para tu regalo 🎁';
    caja.innerHTML =
      '<p class="yz-gift-progress__txt">' + txt + '</p>' +
      '<span class="yz-gift-progress__track"><span class="yz-gift-progress__fill" style="width:' + pct + '%"></span></span>' +
      '<span class="yz-gift-progress__hitos"><span class="ok">✓ Envío gratis</span>' +
      '<span' + (llega ? ' class="ok"' : '') + '>' + (llega ? '✓ ' : '') + 'Regalo · ' + euros(minimo).replace(',00', '') + '</span></span>';

    // La reserva va siempre ENCIMA de la barra
    var reserva = inner.querySelector('.yz-reserva');
    if (reserva && reserva.nextElementSibling !== caja && reserva.parentNode === inner) inner.insertBefore(caja, reserva.nextSibling);
  }

  /* ── 6. UN REGALO Y SOLO UNO ────────────────────────────── 23-ago-2026 ──
     Regla de negocio de Aday, literal: "si una clienta se gasta 75 euros se lleva 1
     regalo, si gasta 200 se lleva 1 regalo, NO MAS".

     El flujo normal ya lo cumplia (al elegir regalo se quita el anterior antes de poner
     el nuevo), pero el 23-ago se encontro un camino por el que el carrito podia acabar
     con lineas de mas: el parche de fetch de snippets/yz-bundle.liquid secuestraba la
     llamada del regalo. Eso ya esta arreglado en origen, y esto es la red debajo del
     trapecio: mira el carrito DE VERDAD y recorta lo que sobre.

     Los regalos se reconocen por product_type 'Regalo', que es como se crearon los cinco
     productos de regalo. Si algun dia se crea uno sin ese tipo, este guardia no lo vera:
     el tipo es parte del contrato, no un detalle.

     Los cambios van EN SERIE. El carrito de Shopify no admite que le toques dos lineas a
     la vez sin pisarse: en paralelo, la segunda llamada trabaja sobre un carrito viejo. */
  var recorteEnCurso = false;

  function unRegaloYSoloUno() {
    if (busy || guardEnCurso || recorteEnCurso) return;
    recorteEnCurso = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var regalos = (c.items || []).filter(function (i) { return i.product_type === 'Regalo'; });
        var unidades = regalos.reduce(function (a, i) { return a + i.quantity; }, 0);
        if (regalos.length <= 1 && unidades <= 1) return null;

        console.warn('Carrito con ' + unidades + ' regalos en ' + regalos.length + ' lineas. Se deja uno.');
        var cambios = [];
        regalos.forEach(function (it, idx) {
          if (idx === 0) { if (it.quantity > 1) cambios.push({ id: it.key, quantity: 1 }); }
          else cambios.push({ id: it.key, quantity: 0 });
        });
        return cambios.reduce(function (cadena, cam) {
          return cadena.then(function () { return postJSON('/cart/change.js', cam); });
        }, Promise.resolve()).then(repintarDrawer);
      })
      .catch(function (e) { console.error('Un solo regalo:', e); })
      .finally(function () { recorteEnCurso = false; });
  }

  function arrancar() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    refModal();
    inyectarCSSProgreso();
    var t;
    var repintar = function () {
      /* 19-sep-2026 - LA BARRA DEL REGALO LLEGABA TARDE AL ABRIR EL CARRITO.
         Al anadir desde la ficha, cart-drawer.js cambia el innerHTML del cajon y eso se lleva la
         barra por delante. Solo volvia con el debounce de 250 ms de abajo, y ese reloj se
         reinicia con cada mutacion (abrir el cajon, reenganchar el upsell...), asi que en la
         practica aparecia 300-500 ms despues y empujaba el contenido hacia abajo.
         Se pinta YA, en el mismo callback del observer (microtarea, antes de que el navegador
         dibuje). Es barato y no hace bucle: si la firma no cambia no toca el DOM.
         Guards y recorte de regalos siguen con debounce: esos si hacen red. */
      pintarProgresoRegalo();
      clearTimeout(t);
      t = setTimeout(function () {
        guard();
        unRegaloYSoloUno();
        pintarProgresoRegalo();
        if (modal && !modal.hidden) anclarModal();
        var tracks = document.querySelectorAll('[data-yz-upsell-track]');
        for (var i = 0; i < tracks.length; i++) pintarFlechas(tracks[i]);
      }, 250);
    };
    new MutationObserver(repintar).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(repintar).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    // cart-drawer.js lanza 'cartUpdated' al anadir producto desde la ficha (movil incluido).
    document.addEventListener('cartUpdated', repintar);
    // data-yz-gift-ok / data-yz-base los corrige yz-regalo-umbral-pagado (atributos): los observers no los ven,
    // así que con el cajón abierto se repasan cada segundo (barra y salto del regalo al llegar a 50 €).
    setInterval(function () { if (drawer.classList.contains('active')) { pintarProgresoRegalo(); guard(); } }, 1000);
    repintar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();